"use client";
import React from 'react';
import { useAdminMute } from './AdminMuteProvider';
import { VolumeX, Volume2, CheckCircle, Lightbulb } from '../icons';

interface AdminMutePanelProps {
  page: 'movement' | 'network';
  className?: string;
}

export const AdminMutePanel: React.FC<AdminMutePanelProps> = ({ page, className = '' }) => {
  const { isAdmin, getMutedCardsForPage, unmuteCard } = useAdminMute();
  const mutedCards = getMutedCardsForPage(page);

  if (!isAdmin) return null;

  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-4 ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <h4 className="font-medium text-gray-900 flex items-center gap-2">
          <VolumeX size={18} strokeWidth={1.5} />
          Admin Mute
        </h4>
        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
          {mutedCards.length} verborgen
        </span>
      </div>

      {mutedCards.length === 0 ? (
        <div className="text-center py-4 text-gray-500">
          <CheckCircle size={32} strokeWidth={1.5} className="mx-auto mb-1 text-green-500" />
          <p className="text-xs">Alle kaarten zichtbaar</p>
        </div>
      ) : (
        <div className="space-y-2">
          {mutedCards.map((card) => (
            <div
              key={card.id}
              className="flex items-center justify-between p-2 bg-red-50 border border-red-200 rounded-lg"
            >
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {card.title}
                </p>
                {card.reason && (
                  <p className="text-xs text-gray-600 truncate">
                    {card.reason}
                  </p>
                )}
                <p className="text-xs text-gray-500">
                  {card.mutedAt.toLocaleDateString('nl-NL', {
                    day: 'numeric',
                    month: 'short',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
              </div>
              <button
                onClick={() => unmuteCard(card.id)}
                className="ml-2 w-6 h-6 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition-colors"
                title={`${card.title} weer zichtbaar maken`}
              >
                <Volume2 size={14} strokeWidth={2} />
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="mt-3 pt-3 border-t border-gray-200">
        <p className="text-xs text-gray-500">
          <span className="flex items-center gap-1">
            <Lightbulb size={12} strokeWidth={1.5} />
            Klik op <VolumeX size={12} strokeWidth={1.5} /> bij kaarten om ze tijdelijk te verbergen
          </span>
        </p>
      </div>
    </div>
  );
};

















